module.exports = __webpack_public_path__ + "img/iconevoltar2.8385d417.png";